module.exports = __webpack_public_path__ + "static/media/icon_hanger.22a1a53c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_hanger.svg
// module id = 704
// module chunks = 0